import * as _ from 'lodash';
import { apis, diagnostics } from '@blend/ui-common';
import { sanitizePii } from '@blend/shared-react';
import { getModeQueryFromParams, TrackingParams } from '@blend/frontend-tracking';
import { getWindow } from 'login-utils/globalWrappers';
import { APP_NAME } from 'login-constants/globals';
import * as loanUtils from 'login-utils/loanUtils';

const sendCreateChangeEvent = (prevState: string | null, nextState: string) =>
  apis.pixelAPI.createStateChange({
    event: {
      prevState,
      nextState,
    },
    labels: {
      app: getWindow().APP_NAME,
    },
  });

export const pixelLog = ({ routes }, store) => {
  const lastRouteName = _.get(store.getState().global.lastAttemptedRoute, 'name');
  const { name } = _.last<RouteState>(routes)!;
  return sendCreateChangeEvent(lastRouteName, name);
};

export const manuallyLogStateChange = (store, nextState: string) => {
  const lastRouteName = _.get(store.getState().global.lastAttemptedRoute, 'name');
  return sendCreateChangeEvent(lastRouteName, nextState);
};

export const sendClickEvent = event => {
  apis.pixelAPI.createClick({
    event,
    labels: {
      app: getWindow().APP_NAME,
    },
  });
};

export interface ClickTrackPropsV2 extends TrackingParams {
  labels?: Record<string, string>;
}

export function trackV2(props: ClickTrackPropsV2, debug?: boolean) {
  const loanId = loanUtils.getSelectedProductId();
  if (debug) {
    const modeQuery = getModeQueryFromParams(props);
    return diagnostics.info(modeQuery);
  }

  // log to pixel
  // no need to await this promise because we don't want to stop user function for pixel
  // tslint:disable-next-line:no-floating-promises
  return apis.pixelAPI
    .createClickV2({
      event: {
        section: props.section,
        elementName: props.elementName,
        elementIndex: props.elementIndex,
        context: props.context,
        sourceId: props.sourceId,
        ...sanitizePii({ elementText: props.elementText }),
      },
      labels: {
        ...(loanId && { loanId }),
        app: APP_NAME,
        ...props.labels,
      },
    })
    .catch(diagnostics.error.bind(diagnostics));
}
